/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component010.less';

interface IComponent010Props {
  text: string;
  img: string;
  className?: string;
  width: string[];
}

const Component010: React.FunctionComponent<IComponent010Props> = ({
  text,
  img,
  className,
  width,
}) => {
  const getImg = (imgage: string) =>
    require(`../../../../../assets/${imgage}`).default;

  return (
    <div className={`component component010 ${className}`}>
      <div
        className="component010-text"
        style={{ width: width ? width[0] : '50%' }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      <div
        className="component010-image"
        style={{ width: width ? width[1] : '50%' }}
      >
        <img src={getImg(img)} />
      </div>
    </div>
  );
};

export default Component010;
